/**
 * window.Flickity, put there by the shared "px-flickity" script (assets/js/flickity.entry.ts): a block that
 * uses it lists "px-flickity" before its own file in block.json `viewScript` and reads it from here instead
 * of importing 'flickity' (which would bundle a second copy). Undefined if that script is missing: the
 * block then stays as it is without JS.
 */
export function getFlickity<T>(): T | undefined {
	return (window as unknown as { Flickity?: T }).Flickity;
}
